import { Box, styled, Typography } from '@mui/material';

export const StyledSupportingProductLinkWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  border: 1px solid ${theme.palette.brand.disable};
  padding: 12px;
  border-radius: 5px;
  align-items: center;
`,
);

export const StyledSupportingProductInfo = styled(Typography)(
  ({ theme }) => `
    a {
     color: ${theme.palette.primary.main};
      text-decoration: none;
      cursor: pointer;
    }
  `,
);
